import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

const data = [
  { scheme: "Scheme May", value: 1150 },
  { scheme: "Scheme July", value: 850 }
];

export default function SchemesOverviewBarChart() {
  const chartData = {
    labels: data.map(d => d.scheme),
    datasets: [
      {
        label: "Schemes",
        data: data.map(d => d.value),
        backgroundColor: [
          "#F5A623", // Orange (Scheme May)
          "#6FBF9B"  // Green (Scheme July)
        ],
        borderRadius: 6,
        barThickness: 80
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#ffffff",
        titleColor: "#3f3f5f",
        bodyColor: "#3f3f5f",
        borderColor: "#E0E0FF",
        borderWidth: 1,
        padding: 12,
        callbacks: {
          label: ctx => ` ${ctx.raw}`
        }
      },
       datalabels: {
      display: false  
    }
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          color: "#6b6b8a",
          font: { size: 13 }
        }
      },
      y: {
        min: 0,
        max: 1200,
        ticks: {
          stepSize: 400,
          color: "#6b6b8a",
          font: { size: 12 }
        },
        grid: {
          color: "rgba(120,120,170,0.15)",
          drawBorder: false
        }
      }
    }
  };

  return (
    <div
      style={{
        height: 260,
        padding: 24,
        borderRadius: 18,
        background:
          "radial-gradient(circle at top,#EDE9FF 0%,#F6F4FF 40%,#FFFFFF 80%)",
        boxShadow: "0 12px 26px rgba(90,111,227,0.12)"
      }}
    >
      <Chart type="bar" data={chartData} options={options} />
    </div>
  );
}
